import { Box } from '@chakra-ui/react';
import { Footer } from 'cj-common-react';
import { useHomeCtx } from 'context/HomeContext';
import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const {
    featureFlags: { showNewBrandUi, useNewArcadiaLogoAndColors }
  } = useHomeCtx();
  return (
    <Box className={'inter-font arcadia-bg'}>
      {children}
      <Footer
        marginTop='26px'
        showNewBrand={showNewBrandUi}
        useArcadiaLogo={useNewArcadiaLogoAndColors}
      />
    </Box>
  );
};
